module.exports = __webpack_public_path__ + "img/elon.c0ab3e24.jpg";